import { connectHits } from 'instantsearch.js/es/connectors'
import { get } from '@bigyouth/base'

const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions

  if (hits.length !== 0) {
    widgetParams.container.innerHTML = '<ul class="row"></ul>'

    hits.forEach((hit) => {
      // create li element, add classes
      const li = document.createElement('li')
      li.classList.add('col-12')
      li.classList.add('md-col-6')
      li.classList.add('lg-col-4')
      li.classList.add('mb-6')
      li.classList.add('flex')

      li.innerHTML = `
      <div class="project-card">
        <div>
          <div class="flex flex-wrap">
            ${hit.thematics
              ? hit.thematics.map(thematic => {
                return `<a href="${thematic.url}" class="thematic thematic--ultralight-blue mr-1 mb-2">${thematic.name}</a>`
              }).join('')
              : ''
            }
          </div>
          <span class="title-4 title-4--medium title-4--white mt-4 block">${hit.title}</span>
          ${hit.description
            ? `<div class="paragraph mt-4">
              ${hit.description}
            </div>`
            : ''
          }
        </div>
        <a onclick="_paq.push(['trackEvent', 'Click', '${config.trads['list.actuality-project.see']}', '${hit.title}'])"
           href="${hit.path}" class="cta cta--white mt-8">${config.trads['list.actuality-project.see']}</a>
      </div>
      `

      get('ul', widgetParams.container).appendChild(li)
    })
  } else {
    widgetParams.container.innerHTML = config.trads['list.actuality.empty']
  }
}

const customHitsActualityProject = connectHits(renderHits)

export default customHitsActualityProject
